<template>
  <footer class="site-footer">
    <b-container>
      <b-row>
        <b-col cols="12" xl="3">
          <h6>Sobre</h6>
          <p class="text-justify-white">
            <i> O Grupo K1 </i>utiliza, há vários anos, diversos procedimentos
            orientados pela sustentabilidade, como a reciclagem dos resíduos
            produzidos na empresa, o tratamento do sistema de esgotos, a
            utilização de plástico reciclado em seus produtos e a produção de
            móveis a partir de madeira de reflorestamento. Tudo rigorosamente
            dentro das leis brasileiras.
          </p>
        </b-col>
        <b-col cols="12" xl="3">
          <h6>INSTITUCIONAL</h6>
          <p></p>

          <ul class="nav flex-column">
            <li class="nav-item">
              <a
                href="#"
                class="nav-link p-0"
                @click="openurl('https://www.kappesberg.com.br/pt/')"
              >
                Quem Somos
              </a>
            </li>
          </ul>
        </b-col>

        <b-col cols="12" xl="3">
          <h6>REDES SOCIAIS</h6>
          <p></p>
          <ul class="nav flex-column">
            <ul class="social-icons">
              <li>
                <a
                  class="facebook"
                  href="#"
                  @click="
                    openurl('https://www.facebook.com/KappesbergOficial/')
                  "
                >
                  <b-icon-facebook />
                </a>
              </li>
              <li>
                <a
                  class="instagram"
                  href="#"
                  @click="
                    openurl('https://www.instagram.com/kappesberg_oficial/')
                  "
                >
                  <b-icon-instagram />
                </a>
              </li>
              <li>
                <a
                  class="youtube"
                  href="#"
                  @click="openurl('https://www.youtube.com/MoveisKappesberg')"
                >
                  <b-icon-youtube />
                </a>
              </li>
              <li>
                <a
                  class="linkedin"
                  href="#"
                  @click="
                    openurl(
                      'https://www.linkedin.com/company/grupo-k1/mycompany/'
                    )
                  "
                >
                  <b-icon-linkedin />
                </a>
              </li>
            </ul>
          </ul>
        </b-col>
        <b-col cols="12" xl="3">
          <h6>LOJA KAPPESBERG</h6>
          <p></p>

          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <a
                href="#"
                class="nav-link p-0"
                @click="openurl('https://loja.kappesberg.com.br/')"
                >www.loja.kappesberg.com.br</a
              >
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <hr />
    <p class="descricao-footer">
      © 2021 KAPPESBERG - CNPJ: 00.912.882/0001-61 - grupo K1 - Rua da
      Emancipação, 2000 - Tupandi/RS - Brasil
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    content: {
      type: String,
    },
  },
  methods: {
    openurl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style>
.site-footer {
  background: linear-gradient(
    to right,
    rgba(235, 63, 93),
    rgba(239, 116, 56),
    rgba(233, 40, 110)
  );
  padding: 45px 0 20px;
  font-size: 15px;
  line-height: 24px;
  color: white;
}

.site-footer hr {
  opacity: 0.5;
}

.site-footer hr.small {
  margin: 20px 0;
}

.site-footer h6 {
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  margin-top: 5px;
  letter-spacing: 2px;
}

.site-footer a {
  color: white;
}

.text-justify-white {
  color: white;
}

.site-footer a:hover {
  color: #3366cc;
  text-decoration: none;
}

.footer-links {
  padding-left: 0;
  list-style: none;
}

.footer-links li {
  display: block;
}

.footer-links a {
  color: white;
}

.footer-links a:active,
.footer-links a:focus,
.footer-links a:hover {
  color: #3366cc;
  text-decoration: none;
}

.footer-links.inline li {
  display: inline-block;
}

.site-footer .social-icons a {
  width: 35px;
  height: 35px;
  line-height: 35px;
  margin-left: 1px;
  margin-right: 1px;
  border-radius: 100%;
  background-color: rgb(72, 81, 86);
  color: white;
}

.copyright-text {
  margin: 0;
}

@media (max-width: 991px) {
  .site-footer [class^="col-"] {
    margin-bottom: 30px;
  }
}

@media (max-width: 767px) {
  .site-footer {
    padding-bottom: 0;
  }

  .site-footer .copyright-text,
  .site-footer .social-icons {
    text-align: center;
  }
}

@media (max-width: 990px) {
  h6 {
    text-align: center;
  }

  ul {
    text-align: center;
  }
}

.social-icons {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  color: white;
}

.social-icons li {
  display: inline-block;
  margin-bottom: 4px;
}

.social-icons li.title {
  margin-right: 15px;
  text-transform: uppercase;
  color: #96a2b2;
  font-weight: 700;
  font-size: 13px;
}

.social-icons a {
  background-color: #eceeef;
  color: white;
  font-size: 16px;
  display: inline-block;
  line-height: 44px;
  width: 44px;
  height: 44px;
  text-align: center;
  margin-right: 8px;
  border-radius: 100%;
  -webkit-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.social-icons a:active,
.social-icons a:focus,
.social-icons a:hover {
  color: #fff;
  background-color: #29aafe;
}

.social-icons.size-sm a {
  line-height: 34px;
  height: 34px;
  width: 34px;
  font-size: 14px;
}

.social-icons a.facebook:hover {
  background-color: #3b5998;
}

.social-icons a.instagram:hover {
  background-color: #ea4c89;
}

.social-icons a.linkedin:hover {
  background-color: #007bb6;
}

.social-icons a.youtube:hover {
  background-color: #db1512;
}

@media (max-width: 767px) {
  .social-icons li.title {
    display: block;
    margin-right: 0;
    font-weight: 600;
  }
}
.descricao-footer {
  color: white;
  text-align: center;
  margin: auto;
}
.nav-item {
  color: white !important;
}
</style>
